// Translation helper using Google Translate API (free, unofficial)
const translationCache = {};

export const LANGUAGES = {
    pt: { code: 'pt', flag: '🇵🇹', name: 'Português' },
    en: { code: 'en', flag: '🇬🇧', name: 'English' },
    fr: { code: 'fr', flag: '🇫🇷', name: 'Français' },
};

export const UI_TRANSLATIONS = {
    pt: {
        searchPlaceholder: 'Buscar produto',
        moreInfo: 'Mais Informações',
        lessInfo: 'Menos Informações',
        seeOnMap: 'ver no mapa',
        location: 'Localização',
        contacts: 'Contatos',
        hours: 'Horário',
        accessFacebook: 'Acessar facebook',
    },
    en: {
        searchPlaceholder: 'Search product',
        moreInfo: 'More Information',
        lessInfo: 'Less Information',
        seeOnMap: 'see on map',
        location: 'Location',
        contacts: 'Contacts',
        hours: 'Hours',
        accessFacebook: 'Access Facebook',
    },
    fr: {
        searchPlaceholder: 'Rechercher un produit',
        moreInfo: 'Plus d\'informations',
        lessInfo: 'Moins d\'informations',
        seeOnMap: 'voir sur la carte',
        location: 'Emplacement',
        contacts: 'Contacts',
        hours: 'Horaires',
        accessFacebook: 'Accéder à Facebook',
    },
};

export const getUIText = (key, lang = 'pt') => {
    return UI_TRANSLATIONS[lang]?.[key] || UI_TRANSLATIONS.pt[key] || key;
};

export const translateText = async (text, targetLang) => {
    if (!text || targetLang === 'pt') {
        return text;
    }

    const cacheKey = `${text}_${targetLang}`;
    if (translationCache[cacheKey]) {
        return translationCache[cacheKey];
    }

    try {
        const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=pt&tl=${targetLang}&dt=t&q=${encodeURIComponent(text)}`;

        const response = await fetch(url);
        const data = await response.json();

        if (data && data[0]) {
            const translatedText = data[0].map(item => item[0]).join('');
            translationCache[cacheKey] = translatedText;
            return translatedText;
        }

        return text;
    } catch (error) {
        console.error('Translation error:', error);
        return text;
    }
};

export const translateProducts = async (products, targetLang) => {
    if (targetLang === 'pt') {
        return products;
    }

    const translatedProducts = await Promise.all(
        products.map(async (product) => {
            if (product === 'menu') return product;

            const [translatedName, translatedDescription, translatedCategoryName] = await Promise.all([
                translateText(product.name, targetLang),
                translateText(product.description, targetLang),
                translateText(product.category?.name, targetLang),
            ]);

            return {
                ...product,
                name: translatedName,
                description: translatedDescription,
                category: product.category ? {
                    ...product.category,
                    name: translatedCategoryName,
                    originalName: product.category.originalName || product.category.name,
                } : product.category,
                originalName: product.originalName || product.name,
                originalDescription: product.originalDescription || product.description,
            };
        })
    );

    return translatedProducts;
};
